import {EventEmitter, Injectable, Output} from '@angular/core';
import {ComponentType} from "@angular/cdk/overlay";
import {MatDialog, MatDialogConfig, MatDialogRef} from "@angular/material/dialog";
import {BaseDialogComponent} from "../../../../../../base/components/base-dialog.component";
import {IDialogData} from "./dialog.model";

@Injectable({
  providedIn: 'root'
})
export class DialogService<RESULT> implements BaseDialogComponent<RESULT> {
  @Output() onCanceled: EventEmitter<void> = new EventEmitter<void>()
  @Output() onCompleted: EventEmitter<RESULT | null> = new EventEmitter<RESULT | null>();

  constructor(private dialog: MatDialog) {
  }

  openWithConfig<D extends IDialogData>(
    component: ComponentType<BaseDialogComponent<RESULT>>,
    config?: MatDialogConfig<D>
  ): MatDialogRef<BaseDialogComponent<RESULT>> {
    const dialogRef = this.dialog.open(component, config)
    let componentRef = dialogRef.componentInstance
    componentRef.onCanceled.subscribe(() => {
      this.onCanceled.emit()
      dialogRef.close()
    })
    componentRef.onCompleted.subscribe((result: RESULT) => {
      this.onCompleted.emit(result)
      dialogRef.close()
    })
    return dialogRef
  }

  open<D extends IDialogData>(
    component: ComponentType<BaseDialogComponent<RESULT>>,
    data: D,
    disableClose: boolean = true
  ): MatDialogRef<BaseDialogComponent<RESULT>> {
    let heightPercent = 70
    let widthPercent = widthPercentage()
    let config = {
      disableClose: disableClose,
      maxHeight: ((window.innerHeight * heightPercent) / 100) + 'px',
      width: ((window.innerWidth * widthPercent) / 100) + 'px',
      // maxWidth: ((window.innerWidth * 70)/100) +'px',
      // minWidth: '300px',
      data: data,
    }
    return this.openWithConfig(component, config)
  }

}


function widthPercentage(): number {
  let width = window.innerWidth
  if (width >= 1600) {
    return 60
  } else if (width >= 1400) return 50
  else if (width >= 1200) return 40
  else if (width >= 992) return 40
  else if (width >= 768) return 70
  else if (width >= 576) return 80
  else return 80
}
